// Copyright (c) 2017 Deere & Company

import TcsmWip from './components';
import actionCreators from './action-creators';
import {connect} from 'react-redux';
import reports from '../../routes/tcsm/reports';

const getStateToBindToContainerProps = state => ({
    ...state.tcsm.wip,
    links: state.app.links,
    reportsRoutes: reports,
    territories: state.user.territories,
    user: state.user.details
});

const mapBoundActionCreatorsToActionsProp = (stateProps, dispatchProps, parentProps) => {

    const {children, routeParams} = parentProps;

    const queryParams = parentProps.location.query;

    return {
        ...stateProps,
        actions: {
            ...dispatchProps
        },
        children,
        queryParams,
        routeParams
    };

};

export default connect(getStateToBindToContainerProps, actionCreators, mapBoundActionCreatorsToActionsProp)(TcsmWip);



// WEBPACK FOOTER //
// ./src/tcsm/wip/state-connector.js